import LocalStorage, { LS_KEY } from '../LocalStorage';

function initPendo(initData, stores) {
    const { analyticsId, isSuperAdmin, license, ctsId, realCustomerId, customerId } = stores.console;
    const { host } = window.location;
    // We need user ids to be unique across environments
    const prefix = initData.env + '_';
    const accountId = prefix + (ctsId || ('unknown_' + (realCustomerId || customerId)));
    const visitorId = prefix + analyticsId;

    window.pendo.initialize({
        visitor: {
            id: visitorId,
            isSuperAdmin,
        },
        account: {
            id: accountId,
            license,
            mirrorRelease: initData.release,
            host,
            env: initData.env,
        },
        excludeAllText: true,
    });
}

export default function tryInitPendo(initData, stores) {
    if (LocalStorage.get(LS_KEY.noPendo)) {
        return;
    }

    const { userId, customerId } = stores.console;

    if (userId !== 0 && customerId && window.pendo) {
        try {
            initPendo(initData, stores);
        } catch (e) {
            // Ignore
        }
    }
}
